import React, { useContext, useState } from 'react';
import { PokedexContext } from '../../Data/Context/pokemonData';
import { BuildContext } from '../../Data/Context/buildData';
import { AppConfigContext } from '../../Config/App';
import uuid from 'uuidv4';
import { LanguageContext } from '../../Data/Context/languageContext';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import personalitiesJson from '../../Data/json/personalities.json';
import abilitiesJson from '../../Data/json/abilities_info.json';
import heldItemsJson from '../../Data/json/held_items.json';
import gearJson from '../../Data/json/gears.json';
import hiddenSkillsJson from '../../Data/json/hidden_skills.json';

const AddItemBtn = ({ modal, index, btnIndex, itemType, classes, imgSrc }) => {
    const { assets_url } = useContext(AppConfigContext)
    const { getPokemonAbilities, pokemonData } = useContext(PokedexContext)
    const { getBtnKey, teammates, pokemonPersonalities, pokemonHeldItems, pokemonHiddenSkills, pokemonGears } = useContext(BuildContext)//Ponto 1 adicioanar variável equivalente à pokemonPersonalities
    const btnStyle = 'btn border rounded-circle d-flex justify-content-center align-items-center add-button box btn-primary'
    const divBtnStyle = 'itemSquare'
    const { buildData, buildDataFromDB, buildMode } = useContext(BuildContext)
    const pokemonPersonalitiesArray = []
    const pokemonHeldItemsArray = []
    const pokemonGearsArray = []
    const pokemonHiddenSkillsArray = []
    const buildTeammates = []
    let buildAbilitiesNumberOfSets = 0
    const { t } = useContext(LanguageContext);
    const [personalityInfo, setPersonalityInfo] = useState("");
    const [abilitiesInfo, setAbilitiesInfo] = useState("");
    const [heldItemsInfo, setHeldIemsInfo] = useState("");
    const [gearInfo, setGearInfo] = useState("");
    const [hiddenSkillsInfo, setHiddenSkillsInfo] = useState("");

    buildTeammates.push(teammates)
    pokemonData.abilities.set_3[0] !== undefined ? buildAbilitiesNumberOfSets = 4 : buildAbilitiesNumberOfSets = 2 //Abilities the pokémon can have

    if (pokemonPersonalities && buildDataFromDB)
        for (let index = 1; index <= 4; index++) pokemonPersonalitiesArray.push(buildDataFromDB.personalities['personality_' + index])

    if (pokemonHeldItems && buildDataFromDB)
        for (let index = 1; index <= 4; index++) pokemonHeldItemsArray.push(buildDataFromDB.heldItems['held_item_' + index])

    if (pokemonGears && buildDataFromDB)
        for (let index = 1; index <= 4; index++) pokemonGearsArray.push(buildDataFromDB.gear['gear_' + index])

    if (pokemonHiddenSkills && buildDataFromDB)
        for (let index = 1; index <= 12; index++) pokemonHiddenSkillsArray.push(buildDataFromDB.hiddenSkills['hidden_skill_' + index])

    function getItems(btnIndex) {
        if (itemType === 'ability')
            getPokemonAbilities(`ability_set_${index}`)

        getBtnKey(btnIndex)
    }

    const updateAbilityInfo = (name) =>
        setAbilitiesInfo(abilitiesJson.find(item => item.name === name.replaceAll('_', ' ').replaceAll('.webp', '')));

    const updatePersonalityInfo = (name) =>
        setPersonalityInfo(personalitiesJson.find(item => item.info.name === name));

    const updateHeldItemInfo = (name) =>
        setHeldIemsInfo(heldItemsJson.find(item => item.info.name === name));

    const updateGearInfo = (name) =>
        setGearInfo(gearJson.find(item => item.info.name === name));

    const updateHiddenSkillInfo = (name) =>
        setHiddenSkillsInfo(hiddenSkillsJson.find(item => item.info.name === name));

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">
                {personalityInfo && personalityInfo.info.name &&
                    <small>{personalityInfo.info.name}</small>
                }
                {abilitiesInfo && abilitiesInfo.name &&
                    <small>{abilitiesInfo.name}</small>
                }
                {heldItemsInfo && heldItemsInfo.info.name &&
                    <small>{heldItemsInfo.info.name}</small>
                }
                {gearInfo && gearInfo.info.name &&
                    <small>{gearInfo.info.name}</small>
                }
                {hiddenSkillsInfo && hiddenSkillsInfo.info.name &&
                    <small>{hiddenSkillsInfo.info.name}</small>
                }
            </Popover.Header>
            <Popover.Body>
                {personalityInfo && personalityInfo.info.positive_stat !== "" ?
                    <>
                        <small id="positive">+10% {personalityInfo.info.positive_stat}</small>
                        <small id="negative">-10% {personalityInfo.info.negative_stat}</small>
                    </>
                    :
                    personalityInfo &&
                    <small id="negative">No changes</small>
                }
                {abilitiesInfo && abilitiesInfo.description !== "" &&
                    <small>{abilitiesInfo.description}</small>
                }
                {heldItemsInfo && heldItemsInfo.info.basic_effect !== "" &&
                    <small>{heldItemsInfo.info.basic_effect}</small>
                }
                {gearInfo && gearInfo.info.description !== "" &&
                    <small>{gearInfo.info.description}</small>
                }
                {hiddenSkillsInfo && hiddenSkillsInfo.info.description !== "" &&
                    <small>{hiddenSkillsInfo.info.description}</small>
                }
            </Popover.Body>
        </Popover>
    );

    if (itemType === 'pokemon') {
        if (buildMode === 'building') {
            if (index === 1 || index === 4) {
                return (
                    <button className={`${btnStyle} ${classes}`} type="button" disabled>
                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url("pokedex/thumbnails/" + pokemonData.sprites.pokeland)}></img>
                    </button>
                )
            } else {
                return (
                    <>
                        {Object.values(buildTeammates).map((teammate) => {
                            if (index === 2) {
                                return (
                                    <button key={uuid()} onClick={() => getBtnKey(index)} className={`${btnStyle} ${classes}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled={false}>
                                        {teammates && teammates['teammate_' + index]
                                            ?
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('pokedex/thumbnails/') + teammates['teammate_' + index]}></img>
                                            :
                                            '+'
                                        }
                                    </button>
                                )
                            } else {
                                let fakeIndex
                                if (index === 3) fakeIndex = 2
                                if (index === 5) fakeIndex = 3
                                if (index === 6) fakeIndex = 5

                                if (teammate['teammate_' + fakeIndex]) {
                                    return (
                                        <button key={uuid()} onClick={() => getBtnKey(index)} className={`${btnStyle} ${classes}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled={false}>
                                            {teammates && teammates['teammate_' + index]
                                                ?
                                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('pokedex/thumbnails/') + teammates['teammate_' + index]}></img>
                                                :
                                                '+'
                                            }
                                        </button>
                                    )
                                } else {
                                    return (
                                        <button key={uuid()} className={`${btnStyle} ${classes}`} type="button" disabled>+</button>
                                    )
                                }
                            }
                        })}
                    </>
                )
            }
        }
        else if (buildMode === 'viewing') {
            if (index === 1 || index === 3) {
                return (
                    <>
                        <button className={`${btnStyle} ${classes}`} type="button" disabled>
                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url("pokedex/thumbnails/" + pokemonData.sprites.pokeland)}></img>
                        </button>

                        {buildDataFromDB && buildDataFromDB.teammates['teammate_' + index] &&
                            <button className={`${btnStyle} ${classes}`} type="button">
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('pokedex/thumbnails/') + buildDataFromDB.teammates['teammate_' + index]}></img>
                            </button>
                        }
                    </>
                )
            } else {
                return (
                    <>
                        {buildDataFromDB && buildDataFromDB.teammates['teammate_' + index] &&
                            <button className={`${btnStyle} ${classes}`} type="button">
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('pokedex/thumbnails/') + buildDataFromDB.teammates['teammate_' + index]}></img>
                            </button>
                        }

                    </>
                )
            }
        }
        else if (buildMode === 'editing') {
            if (index === 1 || index === 4) {
                return (
                    <>
                        <button className={`${btnStyle} ${classes}`} type="button" disabled>
                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url("pokedex/thumbnails/" + pokemonData.sprites.pokeland)}></img>
                        </button>
                    </>
                )
            } else {
                let fakeIndex
                if (index === 2) fakeIndex = 1
                if (index === 3) fakeIndex = 2
                if (index === 5) fakeIndex = 3
                if (index === 6) fakeIndex = 4

                if ((buildDataFromDB && buildDataFromDB.teammates['teammate_' + fakeIndex]) || (teammates && teammates['teammate_' + fakeIndex])) {
                    return (
                        <button key={uuid()} onClick={() => getBtnKey(index)} className={`${btnStyle} ${classes}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled={false}>
                            {(buildDataFromDB.teammates['teammate_' + fakeIndex]) || (teammates && teammates['teammate_' + index]) ?
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src=
                                    {
                                        teammates && teammates['teammate_' + index]
                                            ? assets_url('pokedex/thumbnails/') + teammates['teammate_' + index]
                                            : assets_url('pokedex/thumbnails/') + buildDataFromDB.teammates['teammate_' + fakeIndex]
                                    }
                                ></img>
                                :
                                "+"
                            }
                        </button>
                    )
                } else {
                    return (
                        <button key={uuid()} onClick={() => getBtnKey(index)} className={`${btnStyle} ${classes}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled={false}>
                            {teammates['teammate_' + index] ?
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src=
                                    {
                                        teammates && teammates['teammate_' + index] &&
                                        assets_url('pokedex/thumbnails/') + teammates['teammate_' + index]
                                    }
                                ></img>
                                :
                                "+"
                            }
                        </button>
                    )
                }
            }
        }
    }

    if (itemType === 'ability') {
        if (buildMode === 'viewing') {
            const name = imgSrc.replaceAll('_', ' ').replaceAll('.webp', '');
            return (
                <div key={uuid()}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popover} onToggle={() => updateAbilityInfo(imgSrc)}>
                        <button className={`itemsBtn ${btnStyle}`} type="button">
                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt={"Pokeland Legends " + name} src={assets_url('abilities/small/') + imgSrc}></img>
                            <small>{name}</small>
                        </button>
                    </OverlayTrigger>
                </div>
            )
        }
        else if (buildMode === 'building') {
            if (btnIndex === 1) {
                return (
                    <>
                        {buildData && buildData.abilities.ability_1
                            ?
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('abilities/small/') + buildData.abilities['ability_' + btnIndex]}></img>
                                <small>{buildData.abilities['ability_' + btnIndex].replaceAll('_', ' ').replaceAll('.webp', '')}</small>
                            </button>
                            :
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                +<small>{t("ability")} {index}</small>
                            </button>
                        }
                    </>
                )
            }
            else {
                let fakeIndex
                if (btnIndex === 2) fakeIndex = 1

                if (buildAbilitiesNumberOfSets === 4) {
                    if (btnIndex === 3) fakeIndex = 2
                    if (btnIndex === 4) fakeIndex = 3
                    if (btnIndex === 5) fakeIndex = 4
                    if (btnIndex === 6) fakeIndex = 5
                    if (btnIndex === 7) fakeIndex = 6
                    if (btnIndex === 8) fakeIndex = 7
                } else {
                    if (btnIndex === 5) fakeIndex = 2
                    if (btnIndex === 6) fakeIndex = 5
                }

                return (
                    <>
                        {buildData && buildData.abilities['ability_' + fakeIndex]

                            ?
                            <>
                                {buildData && buildData.abilities['ability_' + btnIndex]
                                    ?
                                    <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('abilities/small/') + buildData.abilities['ability_' + btnIndex]}></img>
                                        <small>{buildData.abilities['ability_' + btnIndex].replaceAll('_', ' ').replaceAll('.webp', '')}</small>
                                    </button>
                                    :
                                    <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("ability")} {index}</small>
                                    </button>
                                }
                            </>

                            :
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled>
                                +<small>{t("ability")} {index}</small>
                            </button>
                        }
                    </>
                )
            }
        }
        else if (buildMode === 'editing' && buildData) {
            if (btnIndex === 1) {
                return (
                    <>
                        {(buildData.abilities.ability_1) || (imgSrc !== "")
                            ?
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src=
                                    {
                                        buildData.abilities['ability_' + btnIndex]
                                            ? assets_url('abilities/small/') + buildData.abilities['ability_' + btnIndex].replaceAll(' ', '_')
                                            : assets_url('abilities/small/') + imgSrc
                                    }
                                ></img>
                                <small>
                                    {buildData.abilities['ability_' + btnIndex]
                                        ?
                                        buildData.abilities['ability_' + btnIndex].replaceAll('_', ' ').replaceAll('.webp', '')
                                        :
                                        imgSrc.replaceAll('_', ' ').replaceAll('.webp', '')
                                    }
                                </small>
                            </button>
                            :
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                +<small>{t("ability")} {index}</small>
                            </button>
                        }
                    </>
                )
            }
            else {
                let fakeIndex
                if (btnIndex === 2) fakeIndex = 1

                if (buildAbilitiesNumberOfSets === 4) {
                    if (btnIndex === 3) fakeIndex = 2
                    if (btnIndex === 4) fakeIndex = 3
                    if (btnIndex === 5) fakeIndex = 4
                    if (btnIndex === 6) fakeIndex = 5
                    if (btnIndex === 7) fakeIndex = 6
                    if (btnIndex === 8) fakeIndex = 7
                } else {
                    if (btnIndex === 5) fakeIndex = 2
                    if (btnIndex === 6) fakeIndex = 5
                }

                if (buildData.abilities['ability_' + fakeIndex]) {
                    if (buildData.abilities['ability_' + btnIndex] || imgSrc !== "") {
                        return (
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src=
                                    {
                                        buildData.abilities['ability_' + btnIndex]
                                            ? assets_url('abilities/small/') + buildData.abilities['ability_' + btnIndex].replaceAll(' ', '_')
                                            : assets_url('abilities/small/') + imgSrc
                                    }
                                ></img>
                                <small>
                                    {buildData.abilities['ability_' + btnIndex]
                                        ?
                                        buildData.abilities['ability_' + btnIndex].replaceAll('_', ' ').replaceAll('.webp', '')
                                        :
                                        imgSrc.replaceAll('_', ' ').replaceAll('.webp', '')
                                    }
                                </small>
                            </button>
                        )
                    } else {
                        return (
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                +<small>{t("ability")} {index}</small>
                            </button>
                        )
                    }
                } else {
                    if (buildData.abilities['ability_' + btnIndex] || imgSrc !== "") {
                        return (
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled>
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src=
                                    {
                                        buildData.abilities['ability_' + btnIndex]
                                            ? assets_url('abilities/small/') + buildData.abilities['ability_' + btnIndex].replaceAll(' ', '_')
                                            : assets_url('abilities/small/') + imgSrc
                                    }
                                ></img>
                                <small>
                                    {buildData.abilities['ability_' + btnIndex]
                                        ?
                                        buildData.abilities['ability_' + btnIndex].replaceAll('_', ' ').replaceAll('.webp', '')
                                        :
                                        imgSrc.replaceAll('_', ' ').replaceAll('.webp', '')
                                    }
                                </small>
                            </button>
                        )
                    } else {
                        return (
                            <button onClick={() => getItems(btnIndex)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal} disabled>
                                +<small>{t("ability")} {index}</small>
                            </button>
                        )
                    }
                }
            }
        }
    }

    if (itemType === 'personality' && pokemonPersonalities) {
        if (buildMode === 'viewing') {
            return (pokemonPersonalitiesArray.map((personality) => {
                return (
                    personality &&
                    <OverlayTrigger key={uuid()} trigger={['hover', 'focus']} placement="top" overlay={popover} onToggle={() => updatePersonalityInfo(personality)}>
                        <div className={divBtnStyle}>
                            <button className={`itemsBtn ${btnStyle}`} type="button">
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt={"Pokeland Legends " + personality} src={assets_url('personalities/') + personality.replaceAll(' ', '_') + '.webp'}></img>
                                <small>{personality}</small>
                            </button>
                        </div>
                    </OverlayTrigger>
                )
            }))
        }
        else if (buildMode === 'building') {
            return (pokemonPersonalities.map((personality, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {personality
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('personalities/') + personality.replaceAll(' ', '_') + '.webp'}></img>
                                        <small>{personality}</small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("personality")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonPersonalities[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {personality
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('personalities/') + personality.replaceAll(' ', '_') + '.webp'}></img>
                                            <small>{personality}</small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("personality")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("personality")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
        else if (buildMode === 'editing') {
            return (pokemonPersonalitiesArray.map((personality, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {(pokemonPersonalitiesArray[index]) || (pokemonPersonalities[index])
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                            pokemonPersonalities[index]
                                                ? assets_url('personalities/') + pokemonPersonalities[index].replaceAll(' ', '_') + '.webp'
                                                : assets_url('personalities/') + pokemonPersonalitiesArray[index].replaceAll(' ', '_') + '.webp'}
                                        >
                                        </img>
                                        <small>
                                            {
                                                pokemonPersonalities[index]
                                                    ? pokemonPersonalities[index]
                                                    : pokemonPersonalitiesArray[index]
                                            }
                                        </small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("personality")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if ((pokemonPersonalitiesArray[index - 1]) || (pokemonPersonalities[index - 1])) {
                        return (
                            <div key={uuid()}>
                                {(pokemonPersonalitiesArray[index]) || (pokemonPersonalities[index])
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                                pokemonPersonalities[index]
                                                    ? assets_url('personalities/') + pokemonPersonalities[index].replaceAll(' ', '_') + '.webp'
                                                    : assets_url('personalities/') + pokemonPersonalitiesArray[index].replaceAll(' ', '_') + '.webp'}
                                            >
                                            </img>
                                            <small>
                                                {
                                                    pokemonPersonalities[index]
                                                        ? pokemonPersonalities[index]
                                                        : pokemonPersonalitiesArray[index]
                                                }
                                            </small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("personality")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("personality")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
    }

    //Ponto 3 Duplicar esta condição AQUI
    if (itemType === 'heldItem' && pokemonHeldItems) {
        if (buildMode === 'viewing') {
            return (pokemonHeldItemsArray.map((heldItem, index) => {
                return (
                    heldItem &&
                    <div key={uuid()}>
                        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popover} onToggle={() => updateHeldItemInfo(heldItem)}>
                            <div className={divBtnStyle}>
                                <button className={`itemsBtn ${btnStyle}`} type="button">
                                    <img loading="lazy" className='border rounded-circle add-button btn-primary' alt={"Pokeland Legends " + heldItem} src={assets_url('items/medium/') + heldItem.replaceAll(' ', '_') + '.webp'}></img>
                                    <small>{heldItem}</small>
                                </button>
                            </div>
                        </OverlayTrigger>
                    </div>
                )
            }))
        }
        else if (buildMode === 'building') {
            return (pokemonHeldItems.map((heldItem, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {heldItem
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('items/medium/') + heldItem.replaceAll(' ', '_') + '.webp'}></img>
                                        <small>{heldItem}</small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("held_item")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonHeldItems[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {heldItem
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('items/medium/') + heldItem.replaceAll(' ', '_') + '.webp'}></img>
                                            <small>{heldItem}</small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("held_item")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("held_item")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
        else if (buildMode === 'editing') {
            return (pokemonHeldItemsArray.map((personality, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {pokemonHeldItemsArray[index] || pokemonHeldItems[index]
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                            pokemonHeldItems[index]
                                                ? assets_url('items/medium/') + pokemonHeldItems[index].replaceAll(' ', '_') + '.webp'
                                                : assets_url('items/medium/') + pokemonHeldItemsArray[index].replaceAll(' ', '_') + '.webp'}
                                        >
                                        </img>
                                        <small>
                                            {
                                                pokemonHeldItems[index]
                                                    ? pokemonHeldItems[index]
                                                    : pokemonHeldItemsArray[index]
                                            }
                                        </small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("held_item")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonHeldItemsArray[index - 1] || pokemonHeldItems[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {pokemonHeldItemsArray[index] || pokemonHeldItems[index]
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                                pokemonHeldItems[index]
                                                    ? assets_url('items/medium/') + pokemonHeldItems[index].replaceAll(' ', '_') + '.webp'
                                                    : assets_url('items/medium/') + pokemonHeldItemsArray[index].replaceAll(' ', '_') + '.webp'}
                                            >
                                            </img>
                                            <small>
                                                {
                                                    pokemonHeldItems[index]
                                                        ? pokemonHeldItems[index]
                                                        : pokemonHeldItemsArray[index]
                                                }
                                            </small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("held_item")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("held_item")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
    }

    if (itemType === 'gear' && pokemonGears) {
        if (buildMode === 'viewing') {
            return (pokemonGearsArray.map((gear, index) => {
                return (
                    gear &&
                    <OverlayTrigger key={uuid()} trigger={['hover', 'focus']} placement="top" overlay={popover} onToggle={() => updateGearInfo(gear)}>
                        <div className={divBtnStyle}>
                            <button className={`itemsBtn ${btnStyle}`} type="button">
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt={"Pokeland Legends " + gear} src={assets_url('gears/small/') + gear.replaceAll(' ', '_') + '_1.webp'}></img>
                                <small>{gear}</small>
                            </button>
                        </div>
                    </OverlayTrigger>
                )
            }))
        }
        else if (buildMode === 'building') {
            return (pokemonGears.map((gear, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {gear
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('gears/small/') + gear.replaceAll(' ', '_') + '_1.webp'}></img>
                                        <small>{gear}</small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("set")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonGears[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {gear
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('gears/small/') + gear.replaceAll(' ', '_') + '_1.webp'}></img>
                                            <small>{gear}</small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("set")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("set")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
        else if (buildMode === 'editing') {
            return (pokemonGearsArray.map((personality, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {pokemonGearsArray[index] || pokemonGears[index]
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                            pokemonGears[index]
                                                ? assets_url('gears/small/') + pokemonGears[index].replaceAll(' ', '_') + '_1.webp'
                                                : assets_url('gears/small/') + pokemonGearsArray[index].replaceAll(' ', '_') + '_1.webp'}
                                        >
                                        </img>
                                        <small>
                                            {
                                                pokemonGears[index]
                                                    ? pokemonGears[index]
                                                    : pokemonGearsArray[index]
                                            }
                                        </small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("set")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonGearsArray[index - 1] || pokemonGears[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {pokemonGearsArray[index] || pokemonGears[index]
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                                pokemonGears[index]
                                                    ? assets_url('gears/small/') + pokemonGears[index].replaceAll(' ', '_') + '_1.webp'
                                                    : assets_url('gears/small/') + pokemonGearsArray[index].replaceAll(' ', '_') + '_1.webp'}
                                            >
                                            </img>
                                            <small>
                                                {
                                                    pokemonGears[index]
                                                        ? pokemonGears[index]
                                                        : pokemonGearsArray[index]
                                                }
                                            </small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("set")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("set")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
    }

    if (itemType === 'hiddenSkill' && pokemonHiddenSkills) {
        if (buildMode === 'viewing') {
            return (pokemonHiddenSkillsArray.map((hiddenSkill, index) => {
                return (
                    hiddenSkill &&
                    <OverlayTrigger key={uuid()} trigger={['hover', 'focus']} placement="top" overlay={popover} onToggle={() => updateHiddenSkillInfo(hiddenSkill)}>
                        <div className={divBtnStyle}>
                            <button className={`itemsBtn ${btnStyle}`} type="button">
                                <img loading="lazy" className='border rounded-circle add-button btn-primary' alt={"Pokeland Legends " + hiddenSkill} src={assets_url('hidden_skills/mobile/') + hiddenSkill.replaceAll(' ', '_') + '.webp'}></img>
                                <small>{hiddenSkill}</small>
                            </button>
                        </div>
                    </OverlayTrigger>
                )
            }))
        }
        else if (buildMode === 'building') {
            return (pokemonHiddenSkills.map((hiddenSkill, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {hiddenSkill
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('hidden_skills/mobile/') + hiddenSkill.replaceAll(' ', '_') + '.webp'}></img>
                                        <small>{hiddenSkill}</small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("hidden_skill")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonHiddenSkills[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {hiddenSkill
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={assets_url('hidden_skills/mobile/') + hiddenSkill.replaceAll(' ', '_') + '.webp'}></img>
                                            <small>{hiddenSkill}</small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("hidden_skill")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("hidden_skill")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
        else if (buildMode === 'editing') {
            return (pokemonHiddenSkillsArray.map((personality, index) => {
                if (index === 0) {
                    return (
                        <div key={uuid()}>
                            {pokemonHiddenSkillsArray[index] || pokemonHiddenSkills[index]
                                ?
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                            pokemonHiddenSkills[index]
                                                ? assets_url('hidden_skills/mobile/') + pokemonHiddenSkills[index].replaceAll(' ', '_') + '.webp'
                                                : assets_url('hidden_skills/mobile/') + pokemonHiddenSkillsArray[index].replaceAll(' ', '_') + '.webp'}
                                        >
                                        </img>
                                        <small>
                                            {
                                                pokemonHiddenSkills[index]
                                                    ? pokemonHiddenSkills[index]
                                                    : pokemonHiddenSkillsArray[index]
                                            }
                                        </small>
                                    </button>
                                </div>
                                :
                                <div className={divBtnStyle}>
                                    <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                        +<small>{t("hidden_skill")} {index + 1}</small>
                                    </button>
                                </div>
                            }
                        </div>
                    )
                } else {
                    if (pokemonHiddenSkillsArray[index - 1] || pokemonHiddenSkills[index - 1]) {
                        return (
                            <div key={uuid()}>
                                {pokemonHiddenSkillsArray[index] || pokemonHiddenSkills[index]
                                    ?
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            <img loading="lazy" className='border rounded-circle add-button btn-primary' alt='alt' src={
                                                pokemonHiddenSkills[index]
                                                    ? assets_url('hidden_skills/mobile/') + pokemonHiddenSkills[index].replaceAll(' ', '_') + '.webp'
                                                    : assets_url('hidden_skills/mobile/') + pokemonHiddenSkillsArray[index].replaceAll(' ', '_') + '.webp'}
                                            >
                                            </img>
                                            <small>
                                                {
                                                    pokemonHiddenSkills[index]
                                                        ? pokemonHiddenSkills[index]
                                                        : pokemonHiddenSkillsArray[index]
                                                }
                                            </small>
                                        </button>
                                    </div>
                                    :
                                    <div className={divBtnStyle}>
                                        <button onClick={() => getItems(index + 1)} className={`itemsBtn ${btnStyle}`} type="button" data-bs-toggle="modal" data-bs-target={modal}>
                                            +<small>{t("hidden_skill")} {index + 1}</small>
                                        </button>
                                    </div>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div className={divBtnStyle} key={uuid()}>
                                <button className={`itemsBtn ${btnStyle}`} type="button" disabled>
                                    +<small>{t("hidden_skill")} {index + 1}</small>
                                </button>
                            </div>
                        )
                    }
                }
            }))
        }
    }
}
export default AddItemBtn;